import React, { useEffect, useState } from "react";
import { useAccount, useDisconnect } from "wagmi";
import { useDispatch, useSelector } from "react-redux";
import {
  setAccountRequest,
  setAccountSuccess,
  setAccountFailure,
} from "../Actions/accountActions";
import {
  setDisconnectWalletRequest,
  setDisconnectWalletSuccess,
  setDisconnectWalletFailure,
} from "../Actions/disconnectWalletActions";

export default function WalletButton() {
  const dispatch = useDispatch();
  const { address, isConnected, isConnecting } = useAccount();
  const { disconnect } = useDisconnect();
  const { success: disconnectTriggered, loading: disconnectLoading } =
    useSelector((state) => state.disconnectWallet);

  const [isClient, setIsClient] = useState(false);
  useEffect(() => setIsClient(true), []);

  useEffect(() => {
    if (isConnected && address) {
      dispatch(setAccountRequest());
      dispatch(setAccountSuccess(address));
    } else {
      dispatch(setAccountFailure({ code: 0, message: "No wallet connected" }));
    }
  }, [address, isConnected, dispatch]);

  const handleLogout = async () => {
    dispatch(setDisconnectWalletRequest());
    try {
      await disconnect();
      dispatch(setAccountSuccess(null));
      dispatch(setDisconnectWalletSuccess());
    } catch (e) {
      dispatch(
        setDisconnectWalletFailure({
          code: 1,
          message: "Error disconnecting wallet",
        })
      );
      console.error("Error disconnecting wallet:", e);
    }
  };

  useEffect(() => {
    if (disconnectTriggered && !isConnecting) {
      (async () => {
        await handleLogout();
      })();
    }
  }, [disconnectTriggered, isConnecting]);

  if (!isClient) return null;

  return (
    <div
      className={`topNavbar-wallet${isConnected ? " connectBtnDivShadow" : ""}`}
    >
      <appkit-button balance={false}></appkit-button>
      {isConnecting && <p id="connectingState">Connecting...</p>}
      {disconnectLoading && <p id="disconnectingState">Disconnecting...</p>}
    </div>
  );
}
